export default __webpack_public_path__ + "static/media/no-notifications1.f0510fb9.svg";